exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".lbaCompanyReferenceCodeSelect_list{margin:1rem 0}.lbaCompanyReferenceCodeSelect_uiSelect{display:inline-block;width:30rem;margin:0 1rem 0 0}.lbaCompanyReferenceCodeSelect_uiSelect .form-control{width:100%}", "", {"version":3,"sources":["/../../../../../sassjs-loader/index.js!/home/vsts/work/1/s/src/components/lbaCompanyReferenceCodeSelect/lbaCompanyReferenceCodeSelect.scss"],"names":[],"mappings":"AAAA,oCACE,aAAe,CAAE,AAEnB,wCACE,qBAAsB,AACtB,YAAa,AACb,iBAAmB,CAAE,AACrB,sDACE,UAAY,CAAE","file":"lbaCompanyReferenceCodeSelect.scss","sourcesContent":[".lbaCompanyReferenceCodeSelect_list {\n  margin: 1rem 0; }\n\n.lbaCompanyReferenceCodeSelect_uiSelect {\n  display: inline-block;\n  width: 30rem;\n  margin: 0 1rem 0 0; }\n  .lbaCompanyReferenceCodeSelect_uiSelect .form-control {\n    width: 100%; }\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/sassjs-loader!./src/components/lbaCompanyReferenceCodeSelect/lbaCompanyReferenceCodeSelect.scss
// module id = 419
// module chunks = 0